var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#74D269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0417 8.163H14.0529L14.0625 10.9564L7.77544 14.625L6.09244 13.6789V13.68L6.08175 13.6733L4.5 12.6591V5.33475L6.22856 4.31494L6.23194 4.31662L7.758 3.375L14.0299 7.06669L14.0417 8.163ZM12.1995 9.9135L10.8838 9.16031L6.49237 11.7444L7.78162 12.5111L12.1995 9.9135ZM10.5874 8.991L7.87837 7.43962L7.86656 10.6352L10.5874 8.991ZM7.8795 7.09763L12.2344 9.64631V8.12475L7.88512 5.58506L7.8795 7.09763ZM6.08625 13.2581L6.10313 11.7321L6.093 11.7382V6.354L4.77281 5.5665V12.474L6.08625 13.2581ZM6.32025 11.5701L7.63931 10.7724V5.5665L6.32025 6.35456V11.5701ZM7.94081 12.7125L7.91437 14.3078L13.7846 10.8562L13.8015 9.27L7.94081 12.7125ZM12.3244 7.884L13.6907 7.10438L7.80975 3.67031L6.45637 4.45331L12.3244 7.884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDta);
export default __webpack_public_path__ + "static/media/dta.68a5a1007f1f720dcd235b095c0ce140.svg";
export { ForwardRef as ReactComponent };